import * as React from "react";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import IconWithText from "../../../../services/Shared/IconWithText/IconWithText";
import { DailyGoals } from "./DailyGoals";
import { ResetStartDateAsync } from "./ResetStartDateAsync";
import { PostDailyGoalsToLogAsync } from "./PostDailyGoalsToLogAsync";

export function LogDailyGoals({ DailyGoals }: { DailyGoals: DailyGoals; }) {
    return (
        <div>
            <IconWithText
                iconSuffix={EGlyphicon["arrow-right"]}
                whenClicked={async () => await PostDailyGoalsToLogAsync(DailyGoals)}
                displayAsBlock={true}
            >
                Log daily goals
            </IconWithText>
            <IconWithText
                iconSuffix={EGlyphicon["arrow-down"]}
                whenClicked={async () => await ResetStartDateAsync(DailyGoals)}
                displayAsBlock={true}
            >
                Reset start date
            </IconWithText>
        </div>
    );
}
